import { lazy } from 'react';

// ----------------------------------------------------------------------

const NotificationsPage = lazy(() => import('../pages/Notifications.page'));

// ----------------------------------------------------------------------

const NotificationsRoutes = [
    {
        path: '/notifications',
        element: <NotificationsPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { NotificationsRoutes };

